import React from "react";
import { useAppContext } from "../../AppProvider";
import { dictionary } from "../../utilities/dictionary";
import { ButtonUtility } from "../../Components/common/Buttons/ButtonUtility";
import { ButtonConfirm } from "../../Components/common/Buttons/ButtonConfirm";
import { useDraftOrderContext } from "./providers/Draft";

const Draft = () => {
  const appContext = useAppContext();
  const language = appContext.language;

  const context = useDraftOrderContext();

  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col">
          <label className="label-4 text-center">
            {dictionary["edit"][language]}
          </label>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col">
          <label className="label-5 text-center">
            {context.orders?.length > 1
              ? `${dictionary["ask_confirm_edit"][language]} ${
                  context.orders?.length
                } ${dictionary["items"][language].toLowerCase()}?`
              : `${dictionary["ask_confirm_edit"][language]}?`}
          </label>
        </div>
      </div>
      <div className="d-flex">
        <ButtonUtility
          className="w-50 me-2"
          onClick={() => {
            if (context.callback) {
              context.callback();
            }
          }}
        >
          {dictionary["cancel"][language]}
        </ButtonUtility>
        <ButtonConfirm
          className="w-50"
          onClick={() => context.draftOrders()}
          disabled={context.ordersLoader}
          loading={context.ordersLoader}
        />
      </div>
    </React.Fragment>
  );
};

export default Draft;
